var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ background: _vm.$root.getTheme().background })},[_c('navbar'),_c('router-view',{staticClass:"router-view"}),_c('loading-screen',{attrs:{"loading":_vm.httpState.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }